'use strict';

class VoteOutput extends BaseComponent {
	static get defaultState() {
		return _.assign(super.constructor.defaultState, {
			updateListFn: RemoteData.getVoteResults,
			choice_1: "Option 1",
			choice_2: "Option 2",
			btnBackEnabled: true,
			btn_back: "Nochmal eingeben"
			// copy: "Vorschläge von anderen Benutzern:"
		})
	}

	constructor(element, state) {
		//init BaseComponent
		super(element, state);
		this.debug = false;

		//set template id
		this._view = $('#atoms_voteOutput_VoteOutput').html();

		//set template props
		this._props = {
			choice_1: this.state.choice_1,
			choice_2: this.state.choice_2,
			btn_back: this.state.btn_back
			// copy: this.state.copy
		};

		//set state
		this.state.votes = [];
		// this.state.newVote = "";

		_.bindAll(this, 'updateList');

		return this
	}

	init() {
		this.$votesList = $('.votes', this.$el);
		// this.$newVote = $('.new-vote', this.$el);
		this.$btnBack = $('.btn-back', this.$el);

		if(!this.state.btnBackEnabled) {
			this.$btnBack.removeClass('hidden');
			this.$btnBack.on('click', (evt) => {
				evt.preventDefault();
				this.$el.trigger(ComponentEvent.RESET)});
		}

		return this
	}

	updateList() {
		return this.state.updateListFn(
			// on success
			(res) => {
				this.state.votes = res.results;
				this.update();
			},
			// on error
			(res) => {
				//TODO ordentliche Fehlerausgabe
				console.error(res);
			}
		);
	}

	update(force = false) {
		if (!_.isEqual(this._internalState, this.state) || force) {
			
			/* this.$votesList.empty(); */

			// this.state.votes.forEach((vote) => {
			// 	let $itm = $(`<li>${vote.title}</li>`);
			// 	this.$votesList.append($itm);
			// });

			// SERVER RESPONSE
			// this.state.votes = [
			// 	{"id":"1","title":"Ei","votes":"0","disabled":"0"},
			// 	{"id":"2","title":"Huhn","votes":"0","disabled":"0"},
			// 	{"id":"170","title":"Huhn","votes":"0","disabled":"0"},
			// 	{"id":"171","title":"Ei","votes":"0","disabled":"0"},
			// 	{"id":"172","title":"Huhn","votes":"0","disabled":"0"}
			// ]

			if(this.debug) console.log('VoteOutput.update() :: votes', this.state.votes);

			// COUNT VOTES
			// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/Reduce

			let totalVotes =  this.state.votes.length;

			let allVotes = this.state.votes.reduce(function(prev, curr) {
				return [...prev, curr.title];
			}, []);

			if(this.debug) console.log('VoteOutput.update() :: allVotes', allVotes);
			// allVotes = [Ei, Huhn, Huhn, Ei, Huhn]

			let countedVotes = allVotes.reduce(function(votes, vote) { 
			if (vote in votes) 
				votes[vote]++;
			else 
				votes[vote] = 1;

			return votes;
			}, {});

			if(this.debug) console.log('VoteOutput.update() :: countedVotes', countedVotes);
			//countedVotes {} = { 'Ei': 2, 'Huhn': 3 }
			//countedVotes [] = [ 'Ei: 2', 'Huhn: 3' ]

			/*
			 * We're no songer saving 'Ei' and 'Huhn' or 'Egg' and 'Chicken' in the database, but merely 'vote_1' and 'vote_2'
			 * This allows translation, but also means the list with the exact number of list items need to be prepared in VoteOutput.html
			 * 
			 *	let percentVotes = 0;
			 *	for (var key in countedVotes) {
			 *		// skip if property is from prototype
			 *		if (!countedVotes.hasOwnProperty(key)) continue;
			 *	
			 *		// console.debug(key); // Ei
			 *		// console.debug(countedVotes[key]); // 2
 			 *	
			 *		percentVotes = 100 / ( totalVotes / countedVotes[key] );
			 *		let $itm = $(`<li>${key} <span class="count">${countedVotes[key]}</span> <span class="count-percent"><span class="count-percent-fill" style="width:${percentVotes}%"></span></span></li>`);
			 *		this.$votesList.append($itm);
			 *	}
			 */

			 /* Apart from the changes below we needed to also remove
			  * update().this.$votesList.empty();
			  */

			 let percentVotes = 0;
			 let i = 0;

			 for (var key in countedVotes) {
				// skip if property is from prototype
				if (!countedVotes.hasOwnProperty(key)) continue;
								
				percentVotes = 100 / ( totalVotes / countedVotes[key] );
				let $spans = $(`<span class="count">(${countedVotes[key]})</span> <span class="count-percent"><span class="count-percent-fill" style="width:${percentVotes}%"></span></span>`);
				this.$votesList.children().eq(i).append($spans);

				i++;
			 }

			if(this.debug) console.log('VoteOutput.update() :: done');

			// this.$newVote.html(this.state.newVote);
			this._internalState = _.clone(this.state);
		}

		return this;
	}
}
